import React from "react";
import { Icons } from "../../components/common/Icons";
import { sidebarItems } from "../../data/internData";
import SearchBar from "../../components/common/SearchBar";
import NotificationBell from "../../components/common/NotificationBell";
import { AvatarDisplay } from "../../components/common/AvatarUpload";
import { useInternData } from "../../context/InternContext";import "../../assets/styles/Intern/InternTopbar.css";

function InternTopbar({ active, onLogout, user, onNav }) {
  const { refreshInternData, notifications } = useInternData();
  const chatUnread = (notifications || []).filter((n) => (n.unread || !n.is_read) && String(n.type || '').toLowerCase() === 'chat').length;
  const label = sidebarItems.find((i) => i.key === active)?.label || "Dashboard";
  return (
    <div className="topbar">
      <div className="topbar-left">
        <div className="topbar-breadcrumb">Intern Portal <Icons.ChevronRight /> <span>{label}</span></div>
      </div>
      <div className="topbar-right">
        <SearchBar portalName="Intern Portal" resetKey={active} />
        <div onClick={() => onNav && onNav("chat")} title="Chat" className="interntopbar-inline-1">
          <Icons.Chat />
          {chatUnread > 0 && <span style={{ "--interntopbar-1-top": `${-6}px`, "--interntopbar-1-right": `${-8}px` }} className="interntopbar-dyn-1">{chatUnread > 99 ? '99+' : chatUnread}</span>}
        </div>
        <div className="interntopbar-inline-2">
          <NotificationBell
            onNavigate={(view) => onNav && onNav(view)}
            onMarkAllRead={refreshInternData} />
          
        </div>
        <div onClick={() => onNav && onNav("profile")} className="interntopbar-inline-3"><AvatarDisplay src={user?.avatar} name={user?.name} size={34} /></div>
        <div className="topbar-icon-btn interntopbar-inline-4" onClick={onLogout} title="Sign Out">
          <Icons.Logout />
        </div>
      </div>
    </div>);

}

export default InternTopbar;